export default __webpack_public_path__ + "static/media/FlyGuy.616132b1.png";